import { fetchFileSasUrl } from "@hooks/queries/use-files";

export async function streamToString(readableStream) {
  const reader = readableStream.getReader();
  const decoder = new TextDecoder("utf-8");
  let result = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break; // Stop reading when stream is finished
    result += decoder.decode(value, { stream: true }); // Incremental decoding
  }

  return result;
}

/**
 * Get a URL or content for a file using file-scoped SAS (one blob only).
 * Accepts either `file.id` or `file.fileId` (split/uncategorised docs carry
 * their id under `fileId`); only the file owner can obtain access.
 */
export async function getFileUrl(file) {
  const { url } = await fetchFileSasUrl(file.id || file.fileId);

  const fileExtension = file.name.split(".").pop().toLowerCase();

  if (fileExtension === "pdf") {
    return { url, type: "pdf" };
  }
  if (["doc", "docx"].includes(fileExtension)) {
    const res = await fetch(url);
    const blob = await res.blob();
    const docBlob = new Blob([blob], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    return { url: URL.createObjectURL(docBlob), type: "doc" };
  }
  const res = await fetch(url);
  const content = await streamToString(res.body);
  return { content, type: "text" };
}
